import Card from "@/components/common/Card";
import type { branch } from "@/interface/branch.interface";

interface BranchSelectorProps {
    branches: branch[];
    isLoading: boolean;
    selectedBranchId: string;
    onChange: (branchId: string) => void;
}

const BranchSelector: React.FC<BranchSelectorProps> = ({
    branches,
    isLoading,
    selectedBranchId,
    onChange,
}) => {
    return (
        <Card className="p-5 border-slate-200/80 rounded-2xl shadow-sm">
            <label className="block text-sm font-bold text-slate-700 mb-2">
                Branch <span className="text-red-500">*</span>
            </label>
            <select
                value={selectedBranchId}
                onChange={(event) => onChange(event.target.value)}
                className="w-full px-4 py-2.5 rounded-xl border border-slate-200 bg-white focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary text-sm font-medium text-slate-700 transition-all"
                disabled={isLoading}
            >
                <option value="">{isLoading ? "Loading branches..." : "-- Select Branch --"}</option>
                {branches.map((item) => (
                    <option key={item.id} value={item.id}>{item.name}</option>
                ))}
            </select>
        </Card>
    );
};

export default BranchSelector;
